import { ChatbotAnswer } from '../../domain/ChatbotSlice/ChatbotAnswer';
import { ChatbotAskAnon } from '../../domain/ChatbotSlice/ChatbotAskAnon';
import ApiWrapper from '../Common/ApiWrapper';

export class ChatbotAnonRepository extends ApiWrapper<ChatbotAnswer> {
    constructor() {
        super('chatbot/anon/');
    }

    async ask(message: ChatbotAskAnon): Promise<ChatbotAnswer | null> {
        return await this.postCustom({url: '', data: message});
    }
}
